import React, { useState, useEffect, Component, useLayoutEffect } from 'react';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
//import axios from "axios";
import axiosInstance from './../../helpers/axiosInstance';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Skeleton from 'react-loading-skeleton';
import iconDetails from '../../assets/img/icons/Icono-Detalles-Blanco.png';
import iconTransfer from '../../assets/img/icons/Icono-Transferencia-Blanco.png';
import iconPay from '../../assets/img/icons/Icono-Pago-Interno-Blanco.png';
import iconProyect from '../../assets/img/icons/Icono-Deuda-Blanco.png';
import { ProductFilter } from './ProductFilter.js';
import { Products } from './ProductsHome/Products';
import { useSelector, useDispatch } from 'react-redux';
import {
  actualizaListProductsHome,
  actulizaInitHome,
  actualizaGroupSelect,
  actualizaProductSelect,
} from '../../Slicersreducers';

// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';
import { ocultarFilter } from 'Slicersreducers';

const _ = require('lodash');

const Carruselproductos = (props) => {
  const [convenios, setConvenios] = useState({
    nombreCuenta: '',

    numeroCuenta: '',
  });
  const [prestamosCuenta, setPrestamosCuenta] = useState({
    numeroPrestamos: '',
  });
  const [CDTA, setCDTA] = useState({
    numeroCDTA: '',
  });
  const [SplitProducts, setSplitProducts] = useState({});
  const [CarouselOptions, setCarouselOptions] = useState([]);
  const [listProducts, setlistProducts] = useState(props.listProducts);
  const [sett, setsett] = useState(props.sett);
  const totalBalance = useSelector((state) => state.miga.balanceTotal);
  const ocultarFilter = useSelector((state) => state.miga.ocultarFilter);
  const initHome = useSelector((state) => state.miga.initHome);
  const groupSelect = useSelector((state) => state.miga.GroupSelect);
  const dispatch = useDispatch();
  const generateLIstCard = () => {
    let listCarouselOptions = [];
    let productSelect = [];
    if (SplitProducts.accounts.length != 0) {
      listCarouselOptions.push({
        title: 'Cuentas Vista / Convenios',
        totalProductos: `${SplitProducts.accounts.length}`,
        totalValue: `${totalBalance.balanceAccounts}`,
        listMovements: SplitProducts.accounts,
        ocultarFiltro: ocultarFilter[0],
        index: 0,
      });
    }

    if (SplitProducts.prestamos.length != 0) {
      listCarouselOptions.push({
        title: 'Cartera Vigente / Préstamos',
        totalProductos: `${SplitProducts.prestamos.length}`,
        totalValue: `${totalBalance.balanceCredit}`,
        listMovements: SplitProducts.prestamos,
        ocultarFiltro: ocultarFilter[1],
        index: 1,
      });
    }

    if (SplitProducts.cdt.length != 0) {
      listCarouselOptions.push({
        title: 'Dépositos a término / CDATS',
        totalProductos: `${SplitProducts.cdt.length}`,
        totalValue: `${totalBalance.balanceCdts}`,
        listMovements: SplitProducts.cdt,
        ocultarFiltro: ocultarFilter[2],
        index: 2,
      });
    }
    if (!initHome) {
      listCarouselOptions.map((item, index) => {
        if (index === 0) {
          productSelect.push(true);
        }
        productSelect.push(false);
      });
      dispatch(actualizaGroupSelect(productSelect));
    }
    setCarouselOptions(listCarouselOptions);
  };

  const SepProducts = () => {
    const accounts =
      listProducts &&
      listProducts.filter(
        (cuenta) => cuenta.accountType === '1' || cuenta.accountType === '2'
      );

    const prestamos =
      listProducts &&
      listProducts.filter(
        (prestamo) =>
          prestamo.accountType === '3' || prestamo.accountType === '6'
      );

    const cdt =
      listProducts && listProducts.filter((cdt) => cdt.accountType === '7');

    setSplitProducts({
      cdt: cdt != null ? cdt : [],
      prestamos: prestamos != null ? prestamos : [],
      accounts: accounts != null ? accounts : [],
    });
  };

  const generateListInitProduct = () => {
    for (const clave in SplitProducts) {
      if (!initHome) {
        if (SplitProducts.hasOwnProperty(clave)) {
          if (SplitProducts[clave].length != 0) {
            const valor = SplitProducts[clave];
            dispatch(actualizaListProductsHome(valor));
            let listProductSelect = [];
            valor.map((item, index) => {
              if (index === 0) {
                listProductSelect.push(true);
              }
              listProductSelect.push(false);
            });
            dispatch(actualizaProductSelect(listProductSelect));
            dispatch(actulizaInitHome(true));
            props.getProductSelect(valor[0]);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (Object.keys(SplitProducts).length === 0) {
      SepProducts();
    } else {
      generateLIstCard();
      generateListInitProduct();
    }
  }, [SplitProducts, totalBalance, ocultarFilter]);

  const handleMovements = (listProducts, i) => {
    let groupListSelect = [];
    dispatch(actualizaListProductsHome(listProducts));
    props.getProductSelect(listProducts[0]);
    if (i != null) {
      groupSelect.map((item, index) => {
        if (i === index) {
          groupListSelect.push(true);
        } else {
          groupListSelect.push(false);
        }
      });
      dispatch(actualizaGroupSelect(groupListSelect));
    }

    let listProductSelect = [];
    listProducts.map((item, index) => {
      if (index === 0) {
        listProductSelect.push(true);
      }
      listProductSelect.push(false);
    });
    dispatch(actualizaProductSelect(listProductSelect));
  };

  return (
    <Col xl="12" md="12" sm="12" style={{ margin: '0px 0px 48px 0px' }}>
      <h1
        className="text-gray-dark mb-0 "
        style={{
          'padding-left': '45px',

          fontSize: '25px',

          margin: '54px 0px 24px 0px',
        }}
      >
        Tus productos
      </h1>

      <Products
        //setFilterData={props.setFilterData}
        data={listProducts}
        settings={sett}
        carouselOptions={CarouselOptions}
        handleMovements={handleMovements}
        deleteTimeAlert={props.deleteTimeAlert}
      />
    </Col>
  );
};

export default Carruselproductos;
